import { StatusRes } from "@/models/statuses.model"
import { PHAClient } from "@/utils/axios"

export const getStatus = async (): Promise<StatusRes> => {
  const response = await PHAClient.get(`/api/status/all`)
  return response.data
}